export default class ModalVideo {
    constructor() {
        this.buttons = document.querySelectorAll('.modal-video__button');
        this.modalBg = document.querySelector('.modal__bg');
        this.modalClose = document.querySelector('.modal__close');

        this.modalBg.addEventListener('click', this.closeModals.bind(this))
        this.modalClose.addEventListener('click', this.closeModals.bind(this))
        
        this.buttons.forEach((el) => {
            el.addEventListener('click', this.toggleModal.bind(this))
        })
    }

    toggleModal(e, target) {
      const currentTarget = target || e.currentTarget;

        if (e.target.hasAttribute('data-modal')) {
            if (e) e.preventDefault();

            const modalSelector = currentTarget.getAttribute('data-modal');
            const modal = document.querySelector(modalSelector);
            currentTarget.classList.toggle('active');
            modal.classList.toggle('open');
            this.modalBg.classList.toggle('active');

            // Inject real iframe src on open
            const iframe = modal.querySelector('iframe[data-src]');
            if (iframe && !iframe.src) {
              iframe.src = iframe.dataset.src + (iframe.dataset.src.includes('?') ? '&' : '?') + 'autoplay=1';
            }
        }
    }

    closeModals(e) {
      document.querySelectorAll('.modal').forEach((el) => {
        el.classList.remove('open');

        // Clear iframe src on close to stop video
        const iframe = el.querySelector('iframe');
        if (iframe) {
          iframe.src = '';
        }
      });

      document.querySelectorAll('.modal__button, .modal__button-hover').forEach((el) => {
        el.classList.remove('active');
      });

      this.modalBg.classList.remove('active');
    }
}
